import { action, makeObservable } from 'mobx'
import { inject, observer } from 'mobx-react'

import FileInputBase from '~/client/src/shared/components/FileInput/FileInput'
import FileType from '~/client/src/shared/enums/FileType'
import { SHOW_FULLSCREEN_PREVIEW } from '~/client/src/shared/stores/EventStore/eventConstants'

import MobileEventStore from '../../stores/EventStore/MobileEvents.store'

interface IFileInputProps {
  id: string
  name: string
  value: string
  onChange?: (newUrlValue, newName) => void
  isReadonly: boolean
  textClassName: string
  isFlexPreview?: boolean
  shouldUseFullSize?: boolean
  shouldHideIconAndOutline?: boolean
  eventsStore?: MobileEventStore
  shouldHideName?: boolean
  className?: string
  projectId: string
}

@inject('eventsStore')
@observer
export default class MobileFileInput extends FileInputBase<IFileInputProps> {
  public constructor(props: IFileInputProps) {
    super(props)
    makeObservable(this)
  }

  @action.bound
  protected showFullscreenPreview(event) {
    this.stopPropagation(event)
    const { value, name, eventsStore } = this.props

    if (value) {
      const file = { fileUrl: value, fileType: FileType.Image, fileName: name }
      eventsStore.dispatch(SHOW_FULLSCREEN_PREVIEW, [file], 0)
    }
  }
}
